import { render, staticRenderFns } from "./SiteTypeDialog.vue?vue&type=template&id=06c89011&scoped=true&"
import script from "./SiteTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SiteTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SiteTypeDialog.vue?vue&type=style&index=0&id=06c89011&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c89011",
  null
  
)

export default component.exports